class TokenList {
    constructor(target, input, options) {
        if(!target.length || !input) return;

        this.target = target;
        this.input = null;
        this.values = [];

        options = (options) ? options : {};
        this.added = (options.added) ? options.added : null;
        this.changed = (options.changed) ? options.changed : null;
        this.limit = (options.limit) ? options.limit : null;
        this.prepend = (options.prepend) ? options.prepend : false;
        this.removed = (options.removed) ? options.removed : null;
        this.separator = (options.separator) ? options.separator : ',';

        if(this.prepend) {
            this.input = $('<input name="' + input + '" type="hidden" value="" />').insertBefore(this.target);
        }
        else {
            this.input = $('<input name="' + input + '" type="hidden" value="" />').insertAfter(this.target);
        }

        this.preload();
    }

    preload() {
        var that = this;
        var items = this.target.find('li');

        if(!items.length) {
            this.target.html('');
        }
        else {
            items.each(function() {
                that.initToken($(this));
                that.values.push(String($(this).data('value')));
            });
        }

        this.change(true);
    }

    change(initiation) {
        var values = this.get();
        this.input.val(values);

        if(!values.length) {
            this.target.html('');
        }

        if(this.changed) {
            this.changed({
                initiation: (initiation) ? true : false,
                limitReached: (!this.limit) ? false : this.values.length >= this.limit,
                values: this.getArray()
            });
        }
    }

    add(options) {
        if(!options || !options.label || !options.value) return;

        options.remove = (options.remove) ? options.remove : false;
        options.special = (options.special) ? options.special : false;
        options.sublabel = (options.sublabel) ? options.sublabel : false;
        options.value = String(options.value);

        if($.inArray(options.value, this.values) > -1) {
            this.highlightToken(this.target.find('li[data-value="' + options.value + '"]'));
        }
        else if(!this.limit || this.values.length < this.limit) {
            var token = null;

            token  = '<li class="' + (options.special ? 'special' : '') + '" data-value="' + options.value + '">';
            token += '<span>' + options.label + '</span>';
            token += (options.sublabel) ? '<span>' + options.sublabel + '</span>' : '';
            token += (options.remove) ? '<a href="#"></a>' : '';
            token += '</li>';
            token  = $(token).appendTo(this.target);

            this.initToken(token);
            this.highlightToken(token);

            this.values.push(options.value);
            this.change();

            if(this.added) {
                this.added({
                    label: options.label,
                    sublabel: options.sublabel,
                    value: options.value
                });
            }
        }
    }

    remove(token) {
        if(this.removed) {
            this.removed({
                label: token.find('span:first-child').text(),
                value: token.data('value')
            });
        }

        token.remove();

        this.values.splice($.inArray(String(token.data('value')), this.values), 1);
        this.change();
    }

    removeAll() {
        var that = this;
        this.target.find('li').each(function() {
            that.remove($(this));
        });
    }

    initToken(token) {
        var that = this;

        token.find('a').bind('click', function() {
            that.remove(token);
            return false;
        });
    }

    highlightToken(token) {
        token.removeClass('transition').addClass('highlighted');

        window.setTimeout(function() {
            token.addClass('transition').removeClass('highlighted');
        }, 800);
    }

    get() {
        if(!this.limit) {
            return this.values.join(this.separator);
        }
        else {
            var values = '';

            for(var i = 0; i < this.limit; i++) {
                if(this.values[i]) {
                    if(i) values += this.separator;
                    values += this.values[i];
                }
            }

            return values;
        }
    }

    getArray() {
        if(!this.limit) {
            return this.values;
        }
        else {
            var values = [];

            for(var i = 0; i < this.limit; i++) {
                if(this.values[i]) {
                    values.push(this.values[i]);
                }
            }

            return values;
        }
    }

    getIntArray() {
        var values = this.getArray();

        for(var i = 0; i < values.length; i++) {
            values[i] = parseInt(values[i]);
        }

        return values;
    }
}

export { TokenList }
